import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/orthotreat.webp';
import screenshot_target from '../../../images/letterfunnel/christopherwilson.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Christopher Wilson"
      firstname="Christopher"
      companyname="Orthotreat"
      competition="Kuros Biosciences en BioSenic"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/christopherwilson.js